<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-fullHeight cs-contentContainer-right-content">
            <workflow :studentId="currentStudentId" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import { getStore } from "@/config/mUtils";
import { getEnableAutonomousEnrolmentSetting } from "@/service/common.service";

import navigator from "../../components/navigator";
import workflow from "../../components/autonomousEnrolment/workflow/main";

export default {
  data() {
    return {
      currentStudentId: 0,
    };
  },
  components: {
    navigator,
    workflow,
  },
  created() {
    if (this.USERMANAGER.isStudent) {
      getEnableAutonomousEnrolmentSetting().then((result) => {
        if (result && result.success) {
          if (!result.data) {
            this.$router.push({
              path: "/studentLanding",
            });
          }
        }
      });

      this.currentStudentId = Number(getStore("user_student_id"));
    }
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/page/addCollectFees/autonomousEnrolment.vue